import { User } from 'api/models';
import { fullName } from 'utils/full-name';

export const getUserLabel = (
  user: Pick<User, 'firstName' | 'lastName' | 'emailId'>,
): string => {
  return fullName(user) || user?.emailId;
};
